export default __webpack_public_path__ + "static/aws_services_partner-57c5926bfa2e2212c7eae4b52ff3232f.png";